import InfoIcon from "@mui/icons-material/InfoOutlined";
import RecipientsIcon from "@mui/icons-material/PeopleOutlineRounded";
import { Stack, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import InlineItemsList from "@entrilia/shared/components/InlineItemsList";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import { pluralize } from "@entrilia/shared/utilities/stringHelper";
import type { InvestorCommunicationFund } from "../../../../../api/types/investorCommunicationsTypes";
import CategoryInlineTags from "../../../../common/CategoryInlineTags";
import InlineAttribute from "../../../../common/InlineAttribute";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import InvestorCommunicationRecipientsPreviewDialog from "../recipients/InvestorCommunicationRecipientsPreviewDialog";
import InvestorCommunicationSettingsTile from "./InvestorCommunicationSettingsTile";

const maxDisplayedItems = 3;

const InvestorCommunicationRecipientsTile = () => {
  const { investorCommunication, recipients, hasEditPermissions, onTabChange } = useDefinedContext(
    InvestorCommunicationContext,
    "InvestorCommunicationContext"
  );

  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  return (
    <InvestorCommunicationSettingsTile
      title="Recipients"
      Icon={RecipientsIcon}
      onView={recipients.length > 0 ? () => setIsPreviewOpen(true) : undefined}
      onEdit={hasEditPermissions ? () => onTabChange("recipients") : undefined}
    >
      <Stack>
        <InlineAttribute
          label="Funds"
          labelWidth="12.5rem"
          value={
            <InlineItemsList<InvestorCommunicationFund>
              items={investorCommunication.funds}
              displayCount={maxDisplayedItems}
              propGetter={(fund) => fund.name}
              popupTitle="Funds"
            />
          }
        />
        <InlineAttribute
          label="Categories"
          labelWidth="12.5rem"
          value={
            <CategoryInlineTags
              externalCategoryIds={investorCommunication.categoryIds}
              maxDisplayedCategories={maxDisplayedItems}
            />
          }
        />
        <InlineAttribute
          label="Estimated recipients"
          labelWidth="12.5rem"
          value={
            <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
              <Typography>
                {recipients.length} {pluralize("recipient", recipients.length)}
              </Typography>
              <Tooltip arrow title="Estimate based on today's matches. The audience is dynamic and can change">
                <InfoIcon color="action" />
              </Tooltip>
            </Stack>
          }
        />
      </Stack>

      {isPreviewOpen && <InvestorCommunicationRecipientsPreviewDialog onClose={() => setIsPreviewOpen(false)} />}
    </InvestorCommunicationSettingsTile>
  );
};

export default InvestorCommunicationRecipientsTile;
